import { request } from '@/shared/api/request'

export const createContract = (payload) => {
	return request({ url: '/contract/sendContract', method: 'POST', data: payload })
}
